import { Tooltip, Typography } from 'antd';
import { Avatar } from 'components/common';
import { OmiChanelChatSourceIcon } from 'components/omni-channel-chat';
import dayjs from 'dayjs';
import React, { memo } from 'react';
import { twMerge } from 'tailwind-merge';
import { ChatSessionDto } from 'types';

type AIChatHistoryItemProps = {
  item: ChatSessionDto;
  selected?: boolean;
  onSelect?: () => void;
};

// Helper chuyển hex (#RRGGBB) sang rgba với alpha; nếu không đúng định dạng hex trả về màu gốc.

const AIChatHistoryItem: React.FC<AIChatHistoryItemProps> = ({ item, selected, onSelect }) => {
  return (
    <div
      className={twMerge(
        'flex w-full cursor-pointer gap-4 px-5 py-3 hover:bg-colorBgItemHover',
        selected && 'bg-colorBgItemHover'
      )}
      onClick={onSelect}
    >
      <div>
        <div className='relative h-12 w-12 rounded-full'>
          <Avatar key={item.chat.customerId} size={48} src={item.chat?.customerAvatar} name={item.chat.customerName} />
          <div className='absolute -bottom-1 right-0 h-5 w-5'>
            <OmiChanelChatSourceIcon size={20} source={item.chat.source} />
          </div>
        </div>
      </div>
      <div className='mt-[3px] flex flex-1 flex-col gap-1'>
        <Typography.Text className='font-semibold leading-5'>{item.chat.customerName}</Typography.Text>
        <Typography.Paragraph className='mb-0 text-sm text-colorTextPlaceholder'>ĐTV AI</Typography.Paragraph>
      </div>
      <div className='mt-[3px] flex flex-col items-end gap-1.5'>
        <Typography.Text className='text-end text-xs' type='secondary'>
          {dayjs(item.completedAt).format('DD/MM')}
        </Typography.Text>
        <Typography.Text className='text-end text-sm'>
          {(() => {
            const totalMinutes = dayjs(item.completedAt).diff(dayjs(item.createdAt), 'minute');
            const hours = Math.floor(totalMinutes / 60);
            const minutes = totalMinutes % 60;

            if (hours > 0) {
              return minutes > 0 ? `${hours}h${minutes}p` : `${hours}h`;
            }
            return `${minutes}p`;
          })()}
        </Typography.Text>
      </div>
    </div>
  );
};

const UserAvatar: React.FC<{ avatar: string; name: string }> = ({ avatar, name }) => {
  return (
    <Tooltip
      prefixCls='avatar-tooltip'
      title={
        <div className='flex items-center gap-2 px-[2px]'>
          <Avatar className='border-white' size={32} src={avatar} name={name} />
          <Typography.Text className='text-sm text-white'>{name}</Typography.Text>
        </div>
      }
      placement='top'
    >
      <Avatar className='border-white' size={24} src={avatar} name={name} />
    </Tooltip>
  );
};

export default memo(AIChatHistoryItem);
